/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
        if (time.indexOf('T') > -1) {
          time = time.replace('T', ' ')
        }
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timestr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on SundaymonthEnDayNum
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return timestr
}

/**
 * 日期时间增减
 * 如(月份减一)：dateAdds(new Date(), -1 ,'m')
 * 年月日时分秒：ymdhMs
 */
export function dateAdds(date, num, fmt) {
  date = new Date(date)
  switch (fmt) {
    case 'y':
      var year = date.getFullYear() + num
      if (date.getDate() == 29 && !isLeapYear(year)) {
        date.setFullYear(year, date.getMonth(), 28)
      // } else if (date.getDate() == 28 && !isLeapYear(date.getFullYear()) && isLeapYear(year)) {
      //   date.setFullYear(year, date.getMonth(), 29)
      } else {
        date.setFullYear(year)
      }
      break;
    case 'm':
      var dateOld = date.getDate()
      var monthNew = date.getMonth() + num
      var dtNew = new Date(date)
      dtNew.setMonth(monthNew)
      while (dtNew.getDate() !== dateOld) {
        dateOld--
        dtNew = new Date(date)
        dtNew.setMonth(monthNew, dateOld)
      }
      date = dtNew
      break;
    case 'd':
      date.setDate(date.getDate() + num)
      break;
    case 'h':
      date.setHours(date.getHours() + num)
      break;
    case 'M':
      date.setMinutes(date.getMinutes() + num)
      break;
    case 's':
      date.setSeconds(date.getSeconds() + num)
      break;
    default:
      break;
  }
  return date
}
/** 判断是否闰年 */
export function isLeapYear(year) {
  // 如果年份能被4整除
  if (year % 4 === 0) {
    // 但不能被100整除，或者能被400整除，则是闰年
    if (year % 100 !== 0 || (year % 100 === 0 && year % 400 === 0)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
/**
 * @param {number} time
 */
export function conversionTime(time) {
  if (time === null || time === undefined || time === '') return ''
  try {
    const d = new Date(time)
    const year = d.getFullYear()
    const month = plusZero(d.getMonth() + 1)
    const day = plusZero(d.getDate())
    const hours = plusZero(d.getHours())
    const minutes = plusZero(d.getMinutes())
    const seconds = plusZero(d.getSeconds())
    if (d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0) {
      return year + '-' + month + '-' + day
    } else if (d.getSeconds() === 0) {
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
    } else {
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    }
  } catch (err) {
    console.log(err.message)
    return time
  }
}
/**
 * @param {number} time
 */
export function conversionyyyyMMdd(time) {
  if (time === null || time === undefined || time === '') return ''
  try {
    const d = new Date(time)
    const year = d.getFullYear()
    const month = plusZero(d.getMonth() + 1)
    const day = plusZero(d.getDate())
    const hours = plusZero(d.getHours())
    const minutes = plusZero(d.getMinutes())
    const seconds = plusZero(d.getSeconds())
    return year + '-' + month + '-' + day
  } catch (err) {
    console.log(err.message)
    return time
  }
}
/**
 * @param {number} time
 */
export function conversionyyyyMM(time) {
  if (time === null || time === undefined || time === '') return ''
  try {
    const d = new Date(time)
    const year = d.getFullYear()
    const month = plusZero(d.getMonth() + 1)
    const day = plusZero(d.getDate())
    const hours = plusZero(d.getHours())
    const minutes = plusZero(d.getMinutes())
    const seconds = plusZero(d.getSeconds())
    return year + '.' + month
  } catch (err) {
    console.log(err.message)
    return time
  }
}

export function monthEnDayNum(time) {
  if (time === null || time === undefined || time === '') return ''
  try {
    const d = new Date(time)
    const day = plusZero(d.getDate())
    const month = d.toDateString().split(' ')[1]
    return day + month
  } catch (err) {
    console.log(err.message)
    return time
  }
}

/**
 * @param {number} time
 */
export function convertYMD(time) {
  if (time === null || time === undefined || time === '') return ''
  try {
    const d = new Date(time)
    const year = d.getFullYear()
    const month = plusZero(d.getMonth() + 1)
    const day = plusZero(d.getDate())
    if (d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0) {
      return year + '-' + month + '-' + day
    } else if (d.getSeconds() === 0) {
      return year + '-' + month + '-' + day
    } else {
      return year + '-' + month + '-' + day
    }
  } catch (err) {
    console.log(err.message)
    return time
  }
}

export function plusZero(val) {
  if (val >= 0 && val <= 9) {
    return '0' + val
  } else {
    return val
  }
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function openLoading(filed) {
  this[filed] = true
}
export function closeLoading(filed) {
  this[filed] = false
}
export function closeLoadingLazy(filed, seconds) {
  var that = this
  setTimeout(function() {
    that[filed] = false
  }, seconds || 1000)
}

export function exportXlsx(loadName, fileName, downFunc, customerFileName) {
  this.openLoading(loadName)

  downFunc().then(data => {
    const myDate = new Date()
    const blob = new Blob([data], {
      type: 'application/vnd.ms-excel'
    })
    let fullFileName = ''
    if (customerFileName !== null && customerFileName !== undefined && customerFileName !== '') {
      fullFileName = customerFileName + '.xlsx'
    } else {
      fullFileName =
      fileName +
      myDate.toLocaleString() +
      Date.parse(new Date()) +
      '.xlsx'
    }

    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, fullFileName)
    } else {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fullFileName
      link.click()
      // 释放内存
      window.URL.revokeObjectURL(link.href)
    }

    this.closeLoadingLazy(loadName)
  }).catch(() => {
    // if (failcallback) {
    //   failcallback
    // }
    this.closeLoading(loadName)
  })
}

export function getNowDate() {
  const timeOne = new Date()
  const year = timeOne.getFullYear()
  let month = timeOne.getMonth() + 1
  let day = timeOne.getDate()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  const NOW_MONTHS_AGO = `${year}-${month}-${day}`
  return NOW_MONTHS_AGO
}

export function calcDays(DateOne, DateTwo) {
  DateOne = convertYMD(DateOne)
  DateTwo = convertYMD(DateTwo)
  var timestamp1 = new Date(DateOne).getTime()
  var timestamp2 = new Date(DateTwo).getTime()

  // 将时间戳相减获得差值（毫秒数）
  var differ = timestamp1 - timestamp2
  /**
   * @desc 毫秒数除以1000就转为秒数
   * @desc 秒数除以60后取整，就是分钟（因为1分钟等于60秒）
   * @desc 秒数除以3600后取整，就是小时（因为1小时等于3600秒）
   * @desc 小时数除以24后取整，就是相差的天数
   */
  var day = differ / 1000 / 60 / 60 / 24
  return Number(day)
}

export function dateAddDays(DateOne, agreeDays) {
  DateOne = convertYMD(DateOne)
  var ADDTIME = agreeDays

  // var OneMonth = DateOne.substring(5, DateOne.lastIndexOf('-'))

  // var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf('-') + 1)

  // var OneYear = DateOne.substring(0, DateOne.indexOf('-'))

  // var dt = new Date(OneYear, OneMonth, OneDay)
  var dt = new Date(DateOne)
  var dtnow = new Date(dt.getTime() + ADDTIME * 24 * 3600 * 1000)

  var nowYear = dtnow.getFullYear()

  var nowMonth = dtnow.getMonth() + 1

  var nowDay = dtnow.getDate()

  if (parseInt(nowMonth) < 10) {
    nowMonth = '0' + nowMonth
  }

  if (parseInt(nowDay) < 10) {
    nowDay = '0' + nowDay
  }

  return nowYear + '-' + nowMonth + '-' + nowDay
}
